export default [
  'disabled',
  'uploadIcon',
  'uploadIconStyle',
  'autoclick',
  'label'
]
